import { Box, TableCell, Typography, styled } from '@mui/material';

const TableDataCell = styled(TableCell)({
    borderBottom: 'none',
    paddingTop: '0.625rem'
});
const TypographyCell = styled(Typography)({
    fontWeight: 'bold',
    display: 'inline'
});

const NormalBox = styled(Box)({
    fontSize: '1em'
});

const BoxRow = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '0.625rem'
});

export { TableDataCell, TypographyCell, NormalBox, BoxRow };
